import { RouteConfig } from 'vue-router'

import LayoutAuth from 'layouts/Auth.vue'
import LayoutAccount from 'layouts/Account.vue'

import LayoutPresenter from 'layouts/Presenter.vue'
import LayoutPresenterItem from 'layouts/PresenterItem.vue'
import LayoutPresenterSession from 'layouts/PresenterSession.vue'
import PagePresenterSession from 'pages/presenter/Session.vue'
import LayoutPresenterSessionShow from 'layouts/PresenterSessionShow.vue'
import PagePresenterSessionShow from 'pages/presenter/SessionShow.vue'
import PagePresenterShare from 'pages/presenter/Share.vue'
import PagePresenterItemContent from 'pages/presenter/ItemContent.vue'
import PagePresenterItemForum from 'pages/presenter/ItemForum.vue'
import PagePresenterItemForumTopic from 'pages/presenter/ItemForumTopic.vue'
import PagePresenterItemTeam from 'pages/presenter/ItemTeam.vue'
import PagePresenterItemCourseStudent from 'pages/presenter/ItemCourseStudent.vue'
import PagePresenterItemCourseStudents from 'pages/presenter/ItemCourseStudents.vue'
import PagePresenterItemSessions from 'pages/presenter/ItemSessions.vue'
import PagePresenterIndex from 'pages/presenter/Index.vue'

import LayoutAttendee from 'layouts/Attendee.vue'
import LayoutAttendeeItem from 'layouts/AttendeeItem.vue'
import LayoutAttendeeSession from 'layouts/AttendeeSession.vue'
import LayoutAttendeeSessionGuest from 'layouts/AttendeeSessionGuest.vue'
import PageAttendeeSession from 'pages/attendee/Session.vue'
import PageAttendeeItemContent from 'pages/attendee/ItemContent.vue'
import PageAttendeeItemForum from 'pages/attendee/ItemForum.vue'
import PageAttendeeItemForumTopic from 'pages/attendee/ItemForumTopic.vue'
import PageAttendeeIndex from 'pages/attendee/Index.vue'

import PageContacts from 'pages/Contacts.vue'
import PageAccount from 'pages/Account.vue'
import PageAuthIndex from 'pages/auth/Index.vue'
import PageIndex from 'pages/Index.vue'
import PageError404 from 'pages/Error404.vue'

const routes: RouteConfig[] = [
  {
    path: '/presenter/session',
    component: LayoutPresenterSession,
    children: [
      {
        path: ':id',
        component: PagePresenterSession
      }
    ]
  },
  {
    path: '/presenter/share',
    component: LayoutPresenter,
    children: [
      {
        name: 'share',
        path: ':id',
        component: PagePresenterShare
      }
    ]
  },
  {
    path: '/presenter/:id',
    component: LayoutPresenterItem,
    children: [
      {
        name: 'content',
        path: '',
        component: PagePresenterItemContent
      },
      {
        name: 'forum',
        path: 'forum',
        component: PagePresenterItemForum
      },
      {
        name: 'forum-topic',
        path: 'forum/:tid',
        component: PagePresenterItemForumTopic
      },
      {
        name: 'team',
        path: 'team',
        component: PagePresenterItemTeam
      },
      {
        name: 'student',
        path: 'student/:sid/:cid?',
        component: PagePresenterItemCourseStudent
      },
      {
        name: 'students',
        path: 'students/:cid?',
        component: PagePresenterItemCourseStudents
      },
      {
        name: 'sessions',
        path: 'sessions',
        component: PagePresenterItemSessions
      }
    ]
  },
  {
    path: '/presenter',
    component: LayoutPresenter,
    children: [
      {
        name: 'presenter',
        path: '',
        component: PagePresenterIndex
      }
    ]
  },
  {
    path: '/attendee/:id/session',
    component: LayoutAttendeeSession,
    children: [
      {
        path: ':sid/:aid?',
        component: PageAttendeeSession
      }
    ]
  },
  {
    path: '/attendee/:id',
    component: LayoutAttendeeItem,
    children: [
      {
        name: 'attendee-content',
        path: '',
        component: PageAttendeeItemContent
      },
      {
        name: 'attendee-forum',
        path: 'forum',
        component: PageAttendeeItemForum
      },
      {
        name: 'attendee-forum-topic',
        path: 'forum/:tid',
        component: PageAttendeeItemForumTopic
      }
    ]
  },
  {
    path: '/attendee',
    component: LayoutAttendee,
    children: [
      {
        name: 'attendee',
        path: '',
        component: PageAttendeeIndex
      }
    ]
  },
  {
    path: '/contacts',
    component: LayoutPresenter,
    children: [
      {
        name: 'contacts',
        path: '',
        component: PageContacts
      }
    ]
  },
  {
    path: '/account',
    component: LayoutAccount,
    children: [
      {
        name: 'account',
        path: '',
        component: PageAccount
      }
    ]
  },
  {
    path: '/auth',
    component: LayoutAuth,
    children: [
      {
        path: '',
        component: PageAuthIndex
      }
    ]
  },
  {
    path: '/guest/show',
    component: LayoutPresenterSessionShow,
    children: [
      {
        path: '',
        component: PagePresenterSessionShow
      }
    ]
  },
  {
    path: '/guest/session/:code',
    component: LayoutAttendeeSessionGuest,
    children: [
      {
        path: '',
        component: PageAttendeeSession
      }
    ]
  },
  {
    path: '/',
    component: LayoutAuth,
    children: [
      {
        path: '',
        component: PageIndex
      }
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: PageError404
  }
]

export default routes
